import "core-js/modules/es6.function.name";
import SelectLazyLoadComponent from "./index.vue";
var SelectLazyLoad = {
  install: function install(Vue) {
    Vue.component(SelectLazyLoadComponent.name, SelectLazyLoadComponent);
  },
  key: SelectLazyLoadComponent.name
};
export default SelectLazyLoad;